const notificationConstants = {
  SET_NOTIFICATION_TRIGGERS: "SET_NOTIFICATION_TRIGGERS",
  RESET_NOTIFICATION_TRIGGERS: "RESET_NOTIFICATION_TRIGGERS",
  UPSERT_TRIGGERS: "UPSERT_TRIGGERS",
  DELETE_TRIGGER: "DELETE_TRIGGER",
  UPSERT_ALERTS: "UPSERT_ALERTS",
};

export default notificationConstants;
